import React from 'react'
import './Corefeature.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const Corefeature = () => {
  return (
        <section className='core-section p-5'>
                        <div class="container text-center">
                                  <div class="row justify-content-around ">
                                      <div class="col-lg-12">
                                        <div class="pg-title-sec">
                                            <h2 class="ws-section_heading mb-5">Our core Features</h2>
                                           
                                        </div>
                                      </div>
                                      <div className='col-lg-12 pt-3'>
                                            <div className='row'>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-1'>
                                                        <FontAwesomeIcon icon="fa-solid fa-chalkboard-user" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>Course delivered by Experts</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-2'>
                                                        <FontAwesomeIcon icon="fa-solid fa-award" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>Superior Training infrastructure<br/>  and Methodology</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-3'>
                                                        <FontAwesomeIcon icon="fa-solid fa-clock" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>24x7 Tool Access for Labs</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-4'>
                                                        <FontAwesomeIcon icon="fa-solid fa-headset" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>100% Placement support <br/> Till get placed</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-5'>
                                                        <FontAwesomeIcon icon="fa-solid fa-book" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>Mock Interview, Mock Tests,<br/>  Course Materials</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-6'>
                                                        <FontAwesomeIcon icon="fa-solid fa-server" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>Powerful EDA Tools</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-2'>
                                                        <FontAwesomeIcon icon="fa-solid fa-credit-card" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>Low Cost & Value for<br/> Money with EMI Facility</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-3'>
                                                        <FontAwesomeIcon icon="fa-solid fa-building" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>300+ Hiring Companies</div>
                                                </div>
                                                 </div>
                                                </div>
                                                <div class="col-lg-4 mb-5 zoom">
                                                <div className='icon radius-1 mb-3'>
                                                        <div className='icon mb-3 b-4'>
                                                        <FontAwesomeIcon icon="fa-solid fa-mobile-screen" />
                                                        </div>
                                                <div className='icon-content'>
                                                    <div className='icon-card-head mb-2'>LMS Access with Learning App</div>
                                                </div>
                                                 </div>
                                                </div>
                                            </div>
                                      </div>
                                  </div>
                                 
                        </div>
                    </section>
    
  )
}

export default Corefeature